import { useRouter, } from 'next/router';

export default function useAuthorId() {
  const router = useRouter();

  return router.query.authorId;
}
